import { IEnrollment } from 'models/enrollment';
import { ILanguage } from "./company";

export interface IWorkshop {
  workshopId: string;
  companyId: string;
  companyName: string;
  companyNameAr: string;
  companyTimeZone: string;
  vendorId: string;
  coHost?:string;
  venueId: string;
  companies?:string[];
  venueName: string;
  isLocked:boolean;
  venueNameAr: string;
  vendorName: string;
  vendorNameAr: string;
  trainerId: string;
  attendanceFrequency:number;
  topicId: string;
  topicName: string;
  topicNameAr: string;
  trainer: string;
  trainerNameAr:string;
  status: number;
  roomNumber: string;
  capacity: number;
  fromDate: string;
  fromTime: any;
  cityId: string;
  cityName: string;
  cityNameAr: string;
  countryId: string;
  countryName: string;
  countryNameAr: string;
  languages: ILanguage[];
  toDate: string;
  toTime: any;
  link: string;
  modality: number;
  competencies: {
    competencyId: string;
    levelOfProficiencyId: string;
  }[];
  averageAttendance: Number;
  averagePreScore: Number;
  averagePostScore: Number;
  averageFinalScore: Number;
  prerequisite: string;
  requiresInvitation:boolean;
  requiresInvitationStr:string;
  workshopEvaluationId: string;
  evaluationValidFrom:  string;
  evaluationValidTo:  string;
  canInvite: boolean;
  fromDateDisplay: string,
  toDateDisplay: string,
  fromTimeDisplay: string,
  toTimeDisplay: string,
  fromEvaluationDateDisplay:  string;
  toEvaluationDateDisplay:  string;
  numberOfEnrollments: number,
  pretestCount: number,
  posttestCount: number,
  evaluationCount:number
}

export interface IEmployeeWorkshopData {
  id: string;
  remainingSeats:number,
  learningOutcome: null;
  learningOutcomeAr: null;
  cityName: string,
  companyId: string;
  companyName: string;
  companyNameAr: string;
  vendorId: string;
  vendorName: string;
  invitationId: string;
  vendorNameAr: string;
  venueId: string;
  trainerBiography: string,
  trainerBiographyAr: string,
  venueName: string;
  venueNameAr: string;
  dates: string;
  time: string;
  totalDuration: string;
  venueLat: number;
  venueLong: number;
  trainerId: string;
  trainer: string;
  trainerAr: string;
  topicId: string;
  topicName: string;
  topicNameAr: string;
  status: number;
  roomNumber: string;
  capacity: number;
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
  link: string;
  modality: number;
  enrollmentId: string;
  canWithdraw: boolean;
  canReject:boolean;
  showWokrshopAssessment: boolean;
  showLocation: boolean;
  canEnroll: boolean;
  workshopId:string,
  enrollmentStatus:any;
  eligibleForCertificate?: boolean;
  timeZone: string;
}

export interface IEmployeeWorkshop {
  completedWorkshops: IEmployeeWorkshopData[];
  openWorkshops: IEmployeeWorkshopData[];
  invitedWorkshops: IEmployeeWorkshopData[];
  enrolledWorkshops: IEmployeeWorkshopData[];
  waitingListWorkshops: IEmployeeWorkshopData[];
}
export interface IEnrollmentList {
  workshopId: string,
  employeeId: string,
  enrollmentId:string,
  name: string,
  status: string,
  statusString: string,
  department: string,
  email: string,
  phoneNumber: string,
  addition: any,
  involvement: any
}

export interface IWaitingList {
  name: string;
  department: string;
  email: string;
  phoneNumber: string;
  addedDate: string;
}

export interface IWorkshopDetails {
  workshopDetails: [IWorkshop];
  enrollmentList: IEnrollmentList[];
  waitingList: IWaitingList[];
}

export interface IEmployeeGrades {
  index: number;
  addition: number;
  eligibleForCertificate: boolean;
  involvement: number;
  pretestScore: number;
  posttestScore: number;
  workshopEvaluationScore?: number;
  rank: number;
  sum: number;
  isLocked:boolean;
  note: string,
  noteAr: string,
  employee: string;
  employeeAr: string;
  enrollmentId: string;  // Changed to camelCase to match API
}

export interface IEmployeeGradeInput {
  addition: number;
  eligibleForCertificate: boolean;
  involvement: number;
  id: string;
}

export interface IWorkshopsGroup {
  id: string;
  companyId: string;
  company: any;
  workshop: any[];
  workshopInvitationRejection: any[];
}

export interface IInviteesList {
  employeeName: string;
  employeeEmail: string;
  status: string;
  rejectionReason: string;
  createdOn: Date;
}

export interface IWorkshopInput {
  vendorId: string;
  venueId: string;
  trainerId?: string;
  topicId: string;
  status: number;
  companies?:string[];
  roomNumber: string;
  capacity: number;
  coHost?:string;
  attendanceFrequency:number;
  fromDate: string;
  toDate: string;
  fromTime: any;
  toTime: any;
  link: string;
  modality: number;
  languages: ILanguage[];
  topicCompetencies: {
    competencyId: string;
    levelOfProficiencyId: string;
  }[];
  prerequisite: string;
  requires_invitation:boolean;
   workshopEvaluationId?: string;
  evaluationValidFrom?: string;
  evaluationValidTo?:  string;
  islocked:boolean
}

export interface IEmployeeWorkshopInput {
  id: string;
  status: number;
  rejectionReason: string;
  workshopId: any;
}

export interface IWorkshopsGroupInput {
  company: any;
}

export enum WorkshopStatus {
  ACTIVE = 1,
  CANCELLED = 2,
  POSTPONED = 3,
}

export interface IWorkshopCancellationReasons {
  id: string;
  description: string;
  descriptionAr: string;
}


export interface IHeadEnrolment  {
  workshopId: string,
  workshopTitle: string,
  enrollmentStatusId: number,
  enrollmentStatus: string,
  approvedOn: string | null,
  approvedBy: string | null,
  employeeName: string,
  enrollmentId:string
}

export interface ISSRSParam {
  Name: string;
  Value: string;
}

export interface ISSRSRequestPayload {
  Path: string;
  SSRSParams: ISSRSParam[];
}

export interface IWorkshopAssessmentMonitor {
  employeeWorkshopAssessmentId: string,
  employeeName: string,
  startedOn : Date,
  completed : boolean,
  elapsedTime: number,
  questionsAnswered : number
}

export interface IWorkshopEvaluationMonitor {
  employeeWorkshopEvaluationId: string,
  employeeName: string,
  startedOn : Date,
  completed : boolean,
  elapsedTime: number,
  questionsAnswered : number
}

export interface IWorkshopEvaluationListItem {
  id: string;
  workshopEvaluationId: string;
  title: string;
  timeToComplete: number;
  isActive: boolean;
}